// * Stories category data section
export const Stories = [
  {
    id: 1,
    category: "داستانی",
    title: "تفنگ چخوف",
    author: "احمد اخوت",
    img: require("./Stories/1.jpg").default,
    pages: 532,
    cover: "شومیز",
  },
  {
    id: 2,
    category: "داستانی",
    title: "فرشته ساز",
    author: "استفان برایس",
    img: require("./Stories/2.jpg").default,
    pages: 496,
    cover: "سلفونی",
  },
  {
    id: 3,
    category: "داستانی",
    title: "دختران روز دی",
    author: "مریم فتاح زاده",
    img: require("./Stories/3.jpg").default,
    pages: 415,
    cover: "شومیز",
  },
  {
    id: 4,
    category: "داستانی",
    title: "خاطرات یک آدمکش",
    author: "خاطره کریمی",
    img: require("./Stories/4.jpg").default,
    pages: 144,
    cover: "شومیز",
  },
  {
    id: 5,
    category: "داستانی",
    title: "انتظار",
    author: "کیوموهندو",
    img: require("./Stories/5.jpg").default,
    pages: 144,
    cover: "شومیز",
  },
  {
    id: 6,
    category: "داستانی",
    title: "دست نوشته های گمشده",
    author: "فرانتس کافکا",
    img: require("./Stories/6.jpg").default,
    pages: 128,
    cover: "سلفونی",
  },
  {
    id: 7,
    category: "داستانی",
    title: "لنی",
    author: "مکس پورتر",
    img: require("./Stories/7.jpg").default,
    pages: 182,
    cover: "شومیز",
  },
  {
    id: 8,
    category: "داستانی",
    title: "سیاه صورت",
    author: "نرجس شکوریان",
    img: require("./Stories/8.jpg").default,
    pages: 216,
    cover: "شومیز",
  },
  {
    id: 9,
    category: "داستانی",
    title: "هتل ساوی",
    author: "یوزف روت",
    img: require("./Stories/9.jpg").default,
    pages: 136,
    cover: "شومیز",
  },
  {
    id: 10,
    category: "داستانی",
    title: "زمانه ی پروانه ها",
    author: "خولیا آلوارز",
    img: require("./Stories/10.jpg").default,
    pages: 424,
    cover: "شومیز",
  },
  {
    id: 11,
    category: "داستانی",
    title: "سکوت ضروری",
    author: "-",
    img: require("./Stories/11.jpg").default,
    pages: 52,
    cover: "شومیز",
  },
  {
    id: 12,
    category: "داستانی",
    title: "فقط یک طاعون ساده",
    author: "اولیتسکایا",
    img: require("./Stories/12.jpg").default,
    pages: 136,
    cover: "شومیز",
  },
  {
    id: 13,
    category: "داستانی",
    title: "سرنوشت مرگبار",
    author: "لوئیز پنی",
    img: require("./Stories/13.jpg").default,
    pages: 452,
    cover: "شومیز",
  },
  {
    id: 14,
    category: "داستانی",
    title: "جنگ دوست داشتنی",
    author: "جولی بری",
    img: require("./Stories/14.jpg").default,
    pages: 448,
    cover: "جلد سخت",
  },
  {
    id: 15,
    category: "داستانی",
    title: "آقای مرسدس",
    author: "استیون کینگ",
    img: require("./Stories/15.jpg").default,
    pages: 574,
    cover: "جلد سخت",
  },
];

// * Fantasies category data section
export const Fantasies = [
  {
    id: 1,
    category: "فانتزی",
    title: "شهر هلالی",
    author: "سارا جی ماس",
    img: require("./Fantasies/1.jpg").default,
    pages: 1024,
    cover: "جلد سخت",
  },
  {
    id: 2,
    category: "فانتزی",
    title: "اشتعال",
    author: "کاترین لسکی",
    img: require("./Fantasies/2.jpg").default,
    pages: 264,
    cover: "شومیز",
  },
  {
    id: 3,
    category: "فانتزی",
    title: "فرزندم پاندا",
    author: "مریم غلامی",
    img: require("./Fantasies/3.jpg").default,
    pages: 120,
    cover: "شومیز",
  },
  {
    id: 4,
    category: "فانتزی",
    title: "بیست و سه",
    author: "رضا قرالو",
    img: require("./Fantasies/4.jpg").default,
    pages: 496,
    cover: "شومیز",
  },
  {
    id: 5,
    category: "فانتزی",
    title: "طلسم لوناری",
    author: "مصطفی اوصانلوی",
    img: require("./Fantasies/5.jpg").default,
    pages: 272,
    cover: "شومیز",
  },
  {
    id: 6,
    category: "فانتزی",
    title: "مانستر",
    author: "ای لی مارتینز",
    img: require("./Fantasies/6.jpg").default,
    pages: 479,
    cover: "شومیز",
  },
  {
    id: 7,
    category: "فانتزی",
    title: "رویاهای خطرناک",
    author: "لارن دیستفانو",
    img: require("./Fantasies/7.jpg").default,
    pages: 133,
    cover: "شومیز",
  },
  {
    id: 8,
    category: "فانتزی",
    title: "عمارت مرموز",
    author: "گرگوری فونارو",
    img: require("./Fantasies/8.jpg").default,
    pages: 193,
    cover: "شومیز",
  },
  {
    id: 9,
    category: "فانتزی",
    title: "تیمارستان متروک",
    author: "دن پابلوکی",
    img: require("./Fantasies/9.jpg").default,
    pages: 276,
    cover: "شومیز",
  },
  {
    id: 10,
    category: "فانتزی",
    title: "داستان یک روح",
    author: "مری داونینگ هان",
    img: require("./Fantasies/10.jpg").default,
    pages: 190,
    cover: "شومیز",
  },
  {
    id: 11,
    category: "فانتزی",
    title: "روح تاریک برف",
    author: "ایندیا هیل براون",
    img: require("./Fantasies/11.jpg").default,
    pages: 198,
    cover: "شومیز",
  },
  {
    id: 12,
    category: "فانتزی",
    title: "زندگی نامرئی ادی لارو",
    author: " ویکتوریا شواب",
    img: require("./Fantasies/12.jpg").default,
    pages: 607,
    cover: "شومیز",
  },
  {
    id: 13,
    category: "فانتزی",
    title: "نم نم باران پاییزی",
    author: "ساناز زینعلی",
    img: require("./Fantasies/13.jpg").default,
    pages: 350,
    cover: "شومیز",
  },
  {
    id: 14,
    category: "فانتزی",
    title: "خیال باز",
    author: "احمد حسن زاده",
    img: require("./Fantasies/14.jpg").default,
    pages: 224,
    cover: "شومیز",
  },
  {
    id: 15,
    category: "فانتزی",
    title: "چشم انداز ستاره",
    author: "برندون سندرسون",
    img: require("./Fantasies/15.jpg").default,
    pages: 512,
    cover: "شومیز",
  },
];

// * Histories category data section
export const Histories = [
  {
    id: 1,
    category: "تاریخی",
    title: "قرن شوروی",
    author: "موشه لووین",
    img: require("./Histories/1.jpg").default,
    pages: 622,
    cover: "زرکوب",
  },
  {
    id: 2,
    category: "تاریخی",
    title: "در باب قرن بیستم",
    author: "تونی جات",
    img: require("./Histories/2.jpg").default,
    pages: 548,
    cover: "شومیز",
  },
  {
    id: 3,
    category: "تاریخی",
    title: "کمونیسم رفت،ما ماندیم و حتی خندیدیم",
    author: "اسلاونکا دراکولیچ",
    img: require("./Histories/3.jpg").default,
    pages: 288,
    cover: "شومیز",
  },
  {
    id: 4,
    category: "تاریخی",
    title: "گشتی در موزه کمونیسم",
    author: "اسلاونکا دراکولیچ",
    img: require("./Histories/4.jpg").default,
    pages: 232,
    cover: "شومیز",
  },
  {
    id: 5,
    category: "تاریخی",
    title: "موزه ی کمونیسم",
    author: "اسلاونکا دراکولیچ",
    img: require("./Histories/5.jpg").default,
    pages: 176,
    cover: "شومیز",
  },
  {
    id: 6,
    category: "تاریخی",
    title: "آکواریوم های پیونگ یانگ",
    author: "کانگ چول-هوان",
    img: require("./Histories/6.jpg").default,
    pages: 340,
    cover: "شومیز",
  },
  {
    id: 7,
    category: "تاریخی",
    title: "خانه های تاریخ",
    author: "یوزف پورتر",
    img: require("./Histories/7.jpg").default,
    pages: 464,
    cover: "آنا گرین",
  },
  {
    id: 8,
    category: "تاریخی",
    title: "قرن دیکتاتورها",
    author: "اولیویه گز",
    img: require("./Histories/8.jpg").default,
    pages: 399,
    cover: "سلفونی",
  },
  {
    id: 9,
    category: "تاریخی",
    title: "از کلیسا تا کرملین",
    author: "کریستیان ویندکه",
    img: require("./Histories/9.jpg").default,
    pages: 228,
    cover: "شومیز",
  },
];

// * Horror category data section
export const Horrors = [
  {
    id: 1,
    category: "وحشت",
    title: "سیلمز لات",
    author: "استیون کینگ",
    img: require("./Horrors/1.jpg").default,
    pages: 580,
    cover: "جلد سخت",
  },
  {
    id: 2,
    category: "وحشت",
    title: "جن گیر",
    author: "پیتر بلاتی",
    img: require("./Horrors/2.jpg").default,
    pages: 355,
    cover: "شومیز",
  },
  {
    id: 3,
    category: "وحشت",
    title: "دختران ساکت",
    author: "اریک ریکستاد",
    img: require("./Horrors/3.jpg").default,
    pages: 230,
    cover: "شومیز",
  },
  {
    id: 4,
    category: "وحشت",
    title: "بیگانه",
    author: "استیون کینگ",
    img: require("./Horrors/4.jpg").default,
    pages: 647,
    cover: "شومیز",
  },
  {
    id: 5,
    category: "وحشت",
    title: "چیزهای تیز",
    author: "گیلین فلین",
    img: require("./Horrors/5.jpg").default,
    pages: 347,
    cover: "شومیز",
  },
  {
    id: 6,
    category: "وحشت",
    title: "سکوت بره ها",
    author: "توماس هریس",
    img: require("./Horrors/6.jpg").default,
    pages: 530,
    cover: "شومیز",
  },
  {
    id: 7,
    category: "وحشت",
    title: "فرانکنشتاین",
    author: "مری شلی",
    img: require("./Horrors/7.jpg").default,
    pages: 270,
    cover: "زرکوب",
  },
  {
    id: 8,
    category: "وحشت",
    title: "عطر",
    author: "پاتریک زوسکیند",
    img: require("./Horrors/8.jpg").default,
    pages: 270,
    cover: "شومیز",
  },
  {
    id: 9,
    category: "وحشت",
    title: "سایه ی باد",
    author: "روئیت ثافون",
    img: require("./Horrors/9.jpg").default,
    pages: 744,
    cover: "شومیز",
  },
  {
    id: 10,
    category: "وحشت",
    title: "تصویر دوریان گری",
    author: "اسکار وایلد",
    img: require("./Horrors/10.jpg").default,
    pages: 312,
    cover: "شومیز",
  },
  {
    id: 11,
    category: "وحشت",
    title: "دراکولا",
    author: "برام استوکر",
    img: require("./Horrors/11.jpg").default,
    pages: 312,
    cover: "شومیز",
  },
  {
    id: 12,
    category: "وحشت",
    title: "کارمیلا",
    author: "شریدن لی فانو",
    img: require("./Horrors/12.jpg").default,
    pages: 128,
    cover: "شومیز",
  },
];

// * Crime category sata section
export const Crimes = [
  {
    id: 1,
    category: "جنایی",
    title: "یک به یک",
    author: "روث ور",
    img: require("./Crimes/1.jpg").default,
    pages: 408,
    cover: "شومیز",
  },
  {
    id: 2,
    category: "جنایی",
    title: "به کشتنش می ارزد",
    author: "پیتر سوانسن",
    img: require("./Crimes/2.jpg").default,
    pages: 344,
    cover: "شومیز",
  },
  {
    id: 3,
    category: "جنایی",
    title: "خشم در هارلم",
    author: "",
    img: require("./Crimes/3.jpg").default,
    pages: 391,
    cover: "شومیز",
  },
  {
    id: 4,
    category: "جنایی",
    title: "راز داوینچی",
    author: "دن براون",
    img: require("./Crimes/4.jpg").default,
    pages: 504,
    cover: "سلفونی",
  },
  {
    id: 5,
    category: "جنایی",
    title: "دختر اینشتین",
    author: "فیلیپ سینگتون",
    img: require("./Crimes/5.jpg").default,
    pages: 528,
    cover: "شومیز",
  },
  {
    id: 6,
    category: "جنایی",
    title: "مرگ در فلورانس",
    author: "مارکو ویچی",
    img: require("./Crimes/6.jpg").default,
    pages: 360,
    cover: "شومیز",
  },
  {
    id: 7,
    category: "جنایی",
    title: "جنون کتاب",
    author: "هوور بارتلت",
    img: require("./Crimes/7.jpg").default,
    pages: 275,
    cover: "شومیز",
  },
  {
    id: 8,
    category: "جنایی",
    title: "خوابگرد قاتل",
    author: "مجتبی هوشیار محبوب",
    img: require("./Crimes/8.jpg").default,
    pages: 296,
    cover: "شومیز",
  },
  {
    id: 9,
    category: "جنایی",
    title: "گومورا",
    author: "روبرتو ساویانو",
    img: require("./Crimes/9.jpg").default,
    pages: 294,
    cover: "شومیز",
  },
];

//  {
//     id: 1,
//     category: "تاریخی",
//     title: "",
//     author: "",
//     img: require("./images/.jpg").default,
//     pages: ,
//     cover: "",
//   },
